import { render, staticRenderFns } from "./updateAreaDialog.vue?vue&type=template&id=7070453e"
import script from "./updateAreaDialog.vue?vue&type=script&lang=ts"
export * from "./updateAreaDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports